

















import Vue from "vue";
import { Header } from "@/components/MyTabs.vue";
import Overview from "./RouteInfo/Overview.vue";
import { axios } from "../../plugins";
import { uuid } from "../../utils/uuid";
import { eventBus } from "../../utils/event";
import { CreateIngressForm } from "./transform";
const Tabs: Header[] = [{ label: "概览", name: "tab1", uuid: uuid() }];

export default Vue.extend({
  name: "TaskInfo",
  components: { Overview },
  props: { projectId: { type: String } },
  data() {
    return {
      Tabs,
      dialog: false,
      tabActive: "tab1",
      routeName: "",
      routeData: JSON.parse(JSON.stringify(CreateIngressForm))
      // statusEnum
    };
  },
  deactivated() {
    this.dialog = false;
    this.tabActive = "tab1";
  },
  watch: {
    tabActive(val) {
      const tab = Tabs.find(item => item.name === val);
      eventBus.$emit("setBeard", { name: (tab as Header).label });
    }
  },
  methods: {
    show(name: string) {
      this.routeName = name;
      this.getRouteData(name, this.projectId).then(() => {
        this.dialog = true;
      });
    },
    close() {
      this.dialog = false;
      this.routeData = JSON.parse(JSON.stringify(CreateIngressForm));
      // 此项设置会触发 tabActive watch
      // 导致 面包屑 触发 setBeard
      // 目前是在面包屑上加 $nextTick
      this.tabActive = "tab1";
    },
    getRouteData(name: string, projectId: string) {
      return axios.get(`/ingress/${projectId}/${name}`).then(res => {
        const data = res.data.data;
        const rules = data.spec.rules;
        rules.map((e: any) => {
          if (data.spec.tls) {
            e.type = "https";
          } else {
            e.type = "http";
          }
          return e;
        });
        this.routeData = {
          name: data.metadata.name,
          description: data.metadata.annotations["appmgr.object.description"],
          updateTime: data.metadata.annotations["appmgr.object.updateTime"],
          createTime: data.metadata.creationTimestamp,
          creator: data.metadata.annotations["appmgr.object.createBy"],
          // ip: data.status.loadBalancer.ingress[0].ip,
          rules
        };
      });
    }
  }
});
